// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"14bf009f","156":"8c72a012","453":"8ab44547","462":"e3e55cb9"}[chunkId] + ".chunk.js";
};